import React from "react"
import PropTypes from "prop-types"
import ReactDropzone from "react-dropzone"
import {observer} from "mobx-react"
import EntreeStore from "../EntreeStore"
import request from "superagent"
import axios from "axios"

@observer
class UploadImagePC extends React.Component {
  constructor(props) {
    super(props);
    this.purge = this.purge.bind(this)
    this.state = {
      files: [],
      images: [],
      preview: false,
      loading: false,
      done: false
    };
  }
  componentDidMount(){
    this.loadImages()
  }

  purge(){
  }
  loadImages(){
  }
  onPreviewDrop = (files) => {
    this.setState({
      files: files,
      preview: true,
      loading: true
     });
    var that = this

    const req = request.post('/api/v1/experts/app/entree/dashboard/uploadImagePC');
    var sendfiles = []
    files.forEach(file => {
      req.attach("images["+file.name+"]", file);
    });
    req.field("id",this.props.id)
    req.field("expertise",this.props.expertise)
    req.field("piece",this.props.piece)
    this.props.reload()
    req.end((err,res)=>{
      that.setState({
        loading: false,
        done: true
      })
    });
  }

  render() {
    const previewStyle = {
      display: 'inline',
      width: 200,
      height: 200,
    };

    return (
        <div className="row">
        {this.state.done &&
          <h2 className="green-text container">enregistrée</h2>
        }
          <div className="col s4 offset-s1">
            <div className="">
            { this.state.preview ? (
              <div>
                {this.state.files.length > 0 &&
                  <React.Fragment>
                    <h3>Previews</h3>
                    {this.state.files.map((file) => (
                      <img
                        alt="Preview"
                        key={file.preview}
                        src={file.preview}
                        style={previewStyle}
                      />
                    ))}
                </React.Fragment>
                }
            </div>
            ) : (
              <div>

              </div>
            )}
          </div>
          </div>
          <div className="col s5 center ">
          {this.state.loading ? (
              <div>
                <p>Upload de l'image en cours</p>
              </div>
            ) : (
              <ReactDropzone
                accept="image/*"
                onDrop={this.onPreviewDrop}
                multiple={true}
                maxSize={500000}
              >
               <h2> amenez les images ici !</h2>
              </ReactDropzone>

            )}


          </div>

      </div>
    );
  }
}

export default UploadImagePC
